// extracted by mini-css-extract-plugin
module.exports = {"coupon_list":"styles_coupon_list__3nusp","separator":"styles_separator__c3AK3","no_coupon":"styles_no_coupon__34978","hidden":"styles_hidden__3Z8xw"};